import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62c5ea45&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/muhu/pts/aics/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCombobox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSheet } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VCard,VCombobox,VContainer,VDataTable,VFlex,VIcon,VLayout,VList,VListTile,VListTileTitle,VMenu,VSheet,VSpacer,VTextField,VTooltip})
